import ServiceAccounts from "@affinity/Store/ServiceAccounts";
import { customDispatch } from "@affinity/Store/ServiceBase";
import ServiceProducts from "@affinity/Store/ServiceProducts";
import { QuantityViewModel } from "@affinity/Store/StoreTypes";
// import ServiceTracking from "@affinity/Store/ServiceTracking";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { OrderCollectionModel, ProductModel, ShipToCollectionModel } from "@insite/client-framework/Types/ApiModels";

// External properties to call chain
interface GetQuoteInitialiseParameter {
    productRegularId: string;
    productPremiumId: string;
}

// Internal chain use
interface Props {
    productRegular: ProductModel;
    productPremium: ProductModel;
    quantityRegular: QuantityViewModel;
    quantityPremium: QuantityViewModel;
    error?: unknown;
}

type HandlerType = Handler<GetQuoteInitialiseParameter, Props>;

export const LoadRegularProduct: HandlerType = async props => {
    if (!props.parameter.productRegularId) {
        return;
    }

    try {
        props.productRegular = await new ServiceProducts().getProductById(props.parameter.productRegularId);
    } catch (error) {
        logger.warn(`Load Regular Product Failed: ${error}`);
        props.error = error;
    }
};

export const LoadPremiumProduct: HandlerType = async props => {
    if (!props.parameter.productPremiumId) {
        return;
    }

    try {
        props.productPremium = await new ServiceProducts().getProductById(props.parameter.productPremiumId);
    } catch (error) {
        logger.warn(`Load Premium Product Failed: ${error}`);
        props.error = error;
    }
};

export const MapTypes: HandlerType = props => {
    const helper = new ServiceProducts();

    if (props.error || !(props.productRegular || !(props.productPremium)))
    {
        // Default
        props.quantityRegular = helper.getDefaultQuantityViewModel();
        props.quantityPremium = helper.getDefaultQuantityViewModel();
        return;
    }

    props.quantityRegular = helper.mapToQuantityViewModel(props.productRegular);
    props.quantityPremium = helper.mapToQuantityViewModel(props.productPremium);
}

export const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/GetQuote/Initialise",
        productRegular: props.productRegular,
        productPremium: props.productPremium,
        quantityRegular: props.quantityRegular,
        quantityPremium: props.quantityPremium,
    });
}

export const Tracking: HandlerType = props => {
    // trackLoadQuantity();
};

export const chain = [
    LoadRegularProduct,
    LoadPremiumProduct,
    MapTypes,
    UpdateState,
    Tracking,
];

const loadFuelProductQuantityViewModel = createHandlerChainRunner(chain, "GetQuoteInitialise");
export default loadFuelProductQuantityViewModel;